import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions as UserSpaceActions } from "redux/slices/v2/UserSpace";
import classes from "./DropDown.module.scss";

const Dropdown = ({
  hideIcon = false,
  className,
  onToggleActive,
  toggleBtnStyle,
  valueComponent,
  liststyling,
  contentComponent,
  dropdownToggle,
  setDropdownToggle,
  fromLp,
  MapMobile = false,
}: {
  hideIcon?: boolean;
  className: string;
  onToggleActive?: string;
  toggleBtnStyle?: string;
  valueComponent: any;
  liststyling?: string;
  contentComponent: any;
  dropdownToggle: boolean;
  t: any;
  setDropdownToggle: (bool: boolean) => void;
  fromLp?: boolean;
  MapMobile?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  const userRedux = useSelector((store: any) => store?.auth?.user);
  const dispatch = useDispatch();

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
        setDropdownToggle(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    setIsOpen(dropdownToggle);
  }, [dropdownToggle]);
  return (
    <div
      className={`${classes.container} ${className} ${isOpen && dropdownToggle ? onToggleActive : ""
        } ${fromLp ? classes.lpContainertoggle : ""}`}
    >
      <div
        className={`${classes.toggle} ${toggleBtnStyle} ${fromLp ? classes.toggleLp : ""
          }`}
        onClick={() => {
          if (hideIcon && !userRedux) {
            dispatch(UserSpaceActions.setIsAuthDialogVisible({ data: true }));
          } else {
            setIsOpen((prev) => !prev);
            setDropdownToggle(dropdownToggle ? false : true);
          }
        }}
      >
        {valueComponent}

        <span>
          {!hideIcon && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="7"
              viewBox="0 0 14 8"
              fill="none"
              className={isOpen && dropdownToggle ? classes.switch_top : ""}
            >
              <path
                d="M13 1L7 7L1 1"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </span>
      </div>
      {isOpen && dropdownToggle && (
        <div
          ref={ref}
          className={`${liststyling && liststyling !== ""
            ? liststyling
            : fromLp
              ? classes.listLp
              : MapMobile ? classes.listMap : classes.list
            } `}
        >
          {contentComponent}
        </div>
      )}
    </div>
  );
};

export default Dropdown;
